import { CalendarDate } from '@internationalized/date';
import { humanReadableDateRange } from '@rematter/ui-web';

import { getLocale } from '~/shared/utils/locale';

type SalesOrderLabelData = {
  documentNumber: string;
  account?: { name?: string | null } | null;
  startDate?: string | CalendarDate | null;
  endDate?: string | CalendarDate | null;
};

type AddressData = {
  streetAddress?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
};

export function formatSalesOrderLabel(entity: SalesOrderLabelData): string {
  return [
    `#${entity.documentNumber}`,
    entity.account?.name,
    entity.startDate &&
      entity.endDate &&
      humanReadableDateRange(entity.startDate, entity.endDate, {
        locale: getLocale(),
      }),
  ]
    .filter(Boolean)
    .join(' ・ ');
}

export function formatAddressDisplay(address: AddressData): string {
  return [
    address.streetAddress,
    address.city,
    address.state,
    address.postalCode,
  ]
    .filter(Boolean)
    .join(', ');
}
